// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1B16B","title":"FrontImage_title__3rKIo"};